import styled, { css, DefaultTheme } from 'styled-components';

export const PersonalizationPanelBodyStyled = styled.div`
  min-height: 3em;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  .visible {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.5s linear;
  }
  .hidden {
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 0s 0.5s,
      opacity 0.5s linear;
  }
`;

export const PersonalizationAudiencesPanelStyled = styled.div`
  min-height: 3em;
  padding: 1em 1em 0 1em;
  margin-bottom: 3.5em;
  display: flex;
  flex-direction: column;
`;

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
    return css`
      height: calc(100dvh - 6.25em);
      @media ${theme.mq.min.tablet} {
        height: calc(100dvh - 3em);
        max-height: 46.5625em;
      }
    `;
  }}
`;
